module.exports = __webpack_public_path__ + "static/media/girl-small.b3ea01c2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Age/girl-small.svg
// module id = 388
// module chunks = 0